import script from "./DecathlonLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DecathlonLoader.vue?vue&type=script&setup=true&lang=ts"

import "./DecathlonLoader.vue?vue&type=style&index=0&id=5d40cb97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d40cb97"]])

export default __exports__